import React from 'react';
import PropTypes from 'prop-types';
import { FolderSection, LabelValue } from '../Elements';
import { t } from '../../common/Translate';
import { useTrade } from '../../../hooks/useCalendar/useRecordBlocs/useTrade';

export const TradeBloc = ({ tradeId, recordId, autobizTradeDate }) => {
  const { goToTrade, openAutobizTradeLink, active, isVisible, status, labels } = useTrade({ tradeId, recordId, autobizTradeDate });

  const handleLinkClick = (e) => {
    e.stopPropagation();
    openAutobizTradeLink();
  };

  return (
    <FolderSection title={t('b2b_plateform')} dataTestid="trade-bloc" action={goToTrade} showArrow={active}>
      {isVisible && (
        <>
          <TradeTag status={status} />
          {labels.map(({ label, value }) => (
            <LabelValue label={label} value={value} />
          ))}

          {(status === 'LIVE' || status === 'live') && (
            <div className="link">
              <span onClick={handleLinkClick} onKeyDown={() => {}} role="button" tabIndex={0}>
                {t('see_add_online')}
              </span>
            </div>
          )}
        </>
      )}
    </FolderSection>
  );
};

const TradeTag = ({ status }) => {
  let color;
  let label;

  switch (status) {
    case 'INACTIVE':
    case 'draft':
      color = 'primary';
      label = 'inactive';
      break;
    case 'SCHEDULED':
    case 'scheduled':
      color = 'primary';
      label = 'saleScheduled';
      break;
    case 'LIVE':
    case 'live':
      color = 'success';
      label = 'online';
      break;
    case 'winner_to_designate':
      color = 'secondary';
      label = 'winnerToDesignate';
      break;
    case 'closed_order_confirmed':
      color = 'secondary';
      label = 'stockClosedOrderConfirmed';
      break;
    case 'closed_no_purchase':
      color = 'secondary';
      label = 'stockClosedNoPurchase';
      break;
    case 'FINISHED':
    case 'CLOSED':
    case 'ARCHIVED':
      color = 'secondary';
      label = 'saleFinished';
      break;
    default:
      break;
  }
  return <span className={`badge badge-${color}`}>{label && t(label)}</span>;
};

TradeBloc.propTypes = {
  tradeId: PropTypes.number,
  recordId: PropTypes.number.isRequired,
};

TradeBloc.defaultProps = {
  tradeId: null,
};

TradeTag.propTypes = {
  status: PropTypes.string,
};

TradeTag.defaultProps = {
  status: undefined,
};
